module.exports = __webpack_public_path__ + "static/Bottom-125f7885bf776a6d588e449eead265ff.svg";